module.exports = __webpack_public_path__ + "static/media/Exitosa.92300284.svg";